import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'
import { ColorEnum } from 'app/utils/mapColors'

export const scrollingCarouselFragment = gql`
  fragment scrollingCarouselFragment on ScrollingCarousel {
    id
    items {
      ... on ScrollingImage {
        __typename
        id
        altText
        image {
          url
          sizes {
            card {
              url
            }
          }
        }
      }
      ... on ScrollingStatCard {
        __typename
        id
        statValue
        label
        backgroundColour
        foregroundColour
      }
    }
  }
`

export type ScrollingImage = {
  __typename: 'ScrollingImage'
  id: string
  altText: string
  image: {
    url: string
    sizes: {
      card: {
        url: string
      }
    }
  }
}

export type ScrollingStatCard = {
  __typename: 'ScrollingStatCard'
  id: string
  statValue: string
  label: string
  backgroundColour: ColorEnum
  foregroundColour: ColorEnum
}

type ScrollingItem = ScrollingImage | ScrollingStatCard

export interface ScrollingCarousel extends GenericBlock<'ScrollingCarousel'> {
  items: ScrollingItem[]
}
